import { useSelector } from 'react-redux';
import cn from 'classnames';
import { HelmetProvider } from 'react-helmet-async';

import Header from 'components/Header';
import Footer from 'components/Footer';
import Router from 'Router';
import Toastify from 'components/common/Toastify';
import ChatNotifications from 'components/common/ChatNotifications';
import SEO from 'components/common/SEO';
import CookieConsentBanner from 'components/common/CookieConsentBanner';
import { ChatSidebarProvider, useChatSidebar } from 'context/ChatSidebarContext';

import './components/PublicTableElements/companyInfo.scss';
import './App.scss';
import 'flag-icons/css/flag-icons.min.css';

const AppContent = () => {
  const authenticated = useSelector((state) => state.auth.authenticated);
  const { isOpen } = useChatSidebar();

  return (
    <div className={cn('App', isOpen && 'chat-sidebar-open')}>
      <SEO />
      <Header />
      <Router />
      <Footer />
      {authenticated && <ChatNotifications />}
      <Toastify />
      <CookieConsentBanner />
      <div id="sidebar" />
    </div>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <ChatSidebarProvider>
        <AppContent />
      </ChatSidebarProvider>
    </HelmetProvider>
  );
};

export default App;
